var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.repeatData.title,
            visible: _vm.dialogVisible,
            width: _vm.repeatData.width,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.repeatData.data !== undefined
            ? _c(
                "div",
                { staticClass: "body mt15" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { staticClass: "repeat-title", attrs: { span: 12 } },
                        [
                          _vm._v(
                            "待办类型：" +
                              _vm._s(
                                _vm.getScheduleName(_vm.repeatData.data.types)
                              )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "text-right repeat-left",
                          attrs: { span: 12 },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.repeatData.data.remind_day) +
                              " " +
                              _vm._s(_vm.repeatData.data.remind_time) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("待办内容：" + _vm._s(_vm.repeatData.data.content)),
                  ]),
                  _vm._v(" "),
                  ["client_renew", "client_track", "client_return"].includes(
                    _vm.repeatData.data.types
                  )
                    ? _c("p", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.repeatData.data.types === "client_track"
                                ? "客户名称"
                                : "合同名称"
                            ) + "："
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "default-color pointer",
                            on: {
                              click: function ($event) {
                                return _vm.toRouterLink()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.repeatData.data.title))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.repeatData.data.types === "personal"
                    ? _c("p", [
                        _vm._v("待办备注：" + _vm._s(_vm.repeatData.data.mark)),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.repeatData.data !== undefined
            ? _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _vm.repeatData.data.types === "personal" ||
                  _vm.repeatData.data.types === "report_renew"
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleEdit },
                        },
                        [_vm._v(_vm._s(_vm.$t("public.edit")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (!_vm.deleteBtn &&
                    _vm.repeatData.data.types === "personal") ||
                  _vm.repeatData.data.types === "report_renew"
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.handleConfirm },
                        },
                        [_vm._v(_vm._s(_vm.$t("public.delete")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.deleteBtn
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.handleOk },
                        },
                        [_vm._v(_vm._s(_vm.$t("login.ok")))]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }